import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Habit, HabitCompletion } from './challenge.model';

@Component({
    selector: 'app-habit-list',
    templateUrl: './habit-list.component.html',
    styleUrls: ['./habit-list.component.scss'],
    standalone: false
})
export class HabitListComponent {
  @Input() dailyHabits: Habit[] = [];
  @Input() weeklyHabits: Habit[] = [];
  @Input() completions: HabitCompletion[] = [];
  @Input() streakByHabitId: { [id: string]: number } = {};
  @Input() availableCategories: string[] = [];
  @Input() activeFilter: string | null = null;
  @Input() today: string = '';

  @Output() filterChange = new EventEmitter<string | null>();
  @Output() toggleDaily = new EventEmitter<Habit>();
  @Output() toggleWeekly = new EventEmitter<Habit>();
  @Output() removeWeeklyCompletion = new EventEmitter<string>();
  @Output() noteChange = new EventEmitter<{ completionId: string, note: string }>();
  @Output() editHabit = new EventEmitter<Habit>();
  @Output() addHabit = new EventEmitter<void>();

  setFilter(category: string | null) { this.filterChange.emit(category); }

  todayCompletionFor(habit: Habit): HabitCompletion | null {
    return this.completions.find(c => c.habitId === habit.id && c.date === this.today) ?? null;
  }

  last7DaysFor(habit: Habit): { date: string, completed: boolean }[] {
    const result: { date: string, completed: boolean }[] = [];
    const datesSet = new Set(this.completions.filter(c => c.habitId === habit.id).map(c => c.date));
    let cursor = this.shiftDate(this.today, -6);
    for (let i = 0; i < 7; i++) {
      result.push({ date: cursor, completed: datesSet.has(cursor) });
      cursor = this.shiftDate(cursor, 1);
    }
    return result;
  }

  weekCompletionsFor(habit: Habit): HabitCompletion[] {
    const today = new Date(this.today + 'T00:00:00');
    const day = today.getDay();
    const offsetToMonday = (day + 6) % 7;
    const monday = new Date(today);
    monday.setDate(today.getDate() - offsetToMonday);
    const mondayStr = this.formatDate(monday);
    const sundayStr = this.shiftDate(mondayStr, 6);
    return this.completions
      .filter(c => c.habitId === habit.id && c.date >= mondayStr && c.date <= sundayStr)
      .sort((a, b) => a.date.localeCompare(b.date));
  }

  private shiftDate(date: string, deltaDays: number): string {
    const d = new Date(date + 'T00:00:00');
    d.setDate(d.getDate() + deltaDays);
    return this.formatDate(d);
  }

  private formatDate(d: Date): string {
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  }

  trackHabit(_index: number, habit: Habit) { return habit.id; }
}
